import smartSolveApi from './instances/smartsolve';

export const getHighVolumeData = async (params) => {
  try {
    const response = await smartSolveApi.post('/getHighVolumeData', params);
    return response.data;
  } catch (e) {
    throw new Error(`getHighVolumeData() failed: ${e}`);
  }
};
